import env from "./envConfig";

export const siftApiConfig = {
	baseURL: env.REACT_APP_SIFT_SERVICE_URL,
	baseApiURL: env.REACT_APP_SIFT_SERVICE_URL,
};
